import React from 'react';

import { TableColumn } from '@hero/ui-kit/tables/Table';

import Link from '../../../components/Link';
import { Organization } from '../api/useGetOrganizations';

type Render = TableColumn<Organization>['render'];

const nameRender: Render = ({ name, id }) => (
    <Link to={`/organizations/${id}/members`}>{name}</Link>
);

type GetTableColumns = () => TableColumn<Organization>[];
const getTableColumns: GetTableColumns = () => [
    {
        colKey: 'name',
        name: 'Name',
        align: 'left',
        headAlign: 'left',
        render: nameRender
    },
    {
        colKey: 'active_members_count',
        name: 'Active Members',
        align: 'right',
        headAlign: 'right',
        render: ({ active_members_count }) => active_members_count
    }
];

export default getTableColumns;
